export const getNextPath = (isForwardRedirect, bidType) => {
  if (isForwardRedirect) return '/assign-quantity';
  return bidType === 'IN_FLEET' ? '/reopen-period' : '';
};

export const genRevertedSelections = (
  invalidSelections,
  standardItems,
  vehicleClassifications,
) => {
  const undoItems = invalidSelections.map((item) => {
    // find vehicle group codes for the program
    const fedStdCodes = new Set(
      vehicleClassifications
        .filter(
          (vc) =>
            vc.parent === item.program && vc.uniqueKey === 'fedStandardCodes',
        )
        .map((vc) => vc.value),
    );
    // find the matching Standard Item in the program
    const undoSi = standardItems.find(
      (si) =>
        +si.id === item.standardItemId && fedStdCodes.has(si.fedStandard.code),
    );
    if (!undoSi) return null; // safe guard; should always find a match
    return {
      ...item,
      sin: undoSi.standardItemNumber,
      title: undoSi.title,
      fedStdCode: undoSi.fedStandard.code,
      vehType: undoSi.vehicleTypeCode.title,
    };
  });
  return undoItems.filter((item) => item !== null);
};

export const mergeSelections = (currentSelections, revertedSelections) => {
  // ! deep copy currentSelections to avoid mutating this state variable
  const newSelections = Object.keys(currentSelections).reduce((acc, key) => {
    acc[key] = [...currentSelections[key]];
    return acc;
  }, {});
  revertedSelections.forEach((item) => {
    const siId = `${item.standardItemId}`;
    if (newSelections[item.fedStdCode]) {
      if (!newSelections[item.fedStdCode].includes(siId))
        newSelections[item.fedStdCode].push(siId);
    } else {
      newSelections[item.fedStdCode] = [siId];
    }
  });
  return newSelections;
};
